const KEY = "kp_watchlist";
const EVT = "kp:watchlist";

export const readWatchlist = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};

const write = (list) => {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event(EVT));
};

export const inWatchlist = (id) => readWatchlist().some((a) => a.id === id);

export const toggleWatchlist = (anime) => {
  const list = readWatchlist();
  const exists = list.some((a) => a.id === anime.id);
  write(exists ? list.filter((a) => a.id !== anime.id) : [{ id: anime.id, title: anime.title, cover_url: anime.cover_url, genres: anime.genres || [], addedAt: Date.now() }, ...list]);
  return !exists;
};

export const onWatchlistChange = (fn) => {
  window.addEventListener(EVT, fn);
  window.addEventListener("storage", fn);
  return () => {
    window.removeEventListener(EVT, fn);
    window.removeEventListener("storage", fn);
  };
};
